/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import {AgencyUserDepositPage} from "../agencyUserDeposit/agencyUserDeposit";
import {AgencyUserRebatePage} from "../agencyUserRebate/agencyUserRebate";
import {AgencyUserTBalancePage} from "../agencyUserTBalance/agencyUserTBalance";
import {AgencyUserBetSearchPage} from "../agencyUserBetSearch/agencyUserBetSearch";
import {AgencyUserZbSearchPage} from "../agencyUserZbSearch/agencyUserZbSearch";
import {AgentUserQuotaPage} from "../agentUserQuota/agentUserQuota";

@Component({
    templateUrl: 'agencyUserList.html',
    selector: 'agency-user-list-page',
})
export class AgencyUserListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    private requestData: any;
    private abalance: any;
    private aparam4: boolean;

    constructor(private nav: NavController, public params: NavParams, private alertCtrl: AlertController,
                private userService: UserService, private loadingCtrl: LoadingController) {
        this.requestData = params.get("requestData");
        this.recordList = this.updateRecordList(params.get("resList"));
        this.recordList.map(item => {
            item["lastlogintime"] = item["lastlogintime"].replace(/-/g,'/');
            return item;
        });
        this.totalNum = params.get("totalRecord");
        this.abalance = params.get("abalance");
        this.aparam4 = params.get("aparam4") == 4;
        this.getFirstData();
    }

    trackByList(index, item) {
        return item.id;
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    itemClick(index: number) {
        this.recordList[index]["show"] = !this.recordList[index]["show"];
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.agentUserSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.recordList = this.updateRecordList(data["reslist"]);
                this.recordList.map(item => {
                    item["lastlogintime"] = item["lastlogintime"].replace(/-/g,'/');
                    return item;
                });
                this.totalNum = data["totalrecord"];
                this.aparam4 = data["aparam4"];
                this.abalance = data["abalance"];
                this.infiniteScrollBoolean = true;
                if ( refresher ) refresher.complete();
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    updateRecordList(list) {
        list.map(item => {
            item["show"] = false;
            if (item["pointssc"] != 0) {
                item["pointssc"] = (item["pointssc"] * 100).toFixed(1);
            }
            return item;
        });
        return list;
    }

    //充值
    deposit(data: any) {
        this.nav.push(AgencyUserDepositPage, {
            abalance: this.abalance,
            data: data
        });
    }

    /**
     * 配额
     * @param id
     */
    // quota(id: string) {
    //   this.nav.push(AgentUserQuotaPage, {
    //     id: id
    //   });
    // }

    /**
     * 编辑返点
     * @param data
     */
    editRebate(data: any) {
        this.nav.push(AgencyUserRebatePage, {
            data: data
        });
    }

    tBalance(data: any) {
        this.nav.push(AgencyUserTBalancePage, {
            data: data
        });
    }

    /**
     * 账变查询
     * @param data
     */
    zbSearch(data: any) {
        this.nav.push(AgencyUserZbSearchPage, {
            data: data
        });
    }

    doInfinite(infiniteScroll) {
        infiniteScroll.enable(false);
        setTimeout(() => {
            let dataParams = this.requestData;
            this.userService.agentUserSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    this.recordList = this.recordList.concat(this.updateRecordList(data["reslist"]));
                    this.recordList.map(item => {
                        item["lastlogintime"] = item["lastlogintime"].replace(/-/g,'/');
                        return item;
                    });
                    this.totalNum = data["totalrecord"];
                    this.aparam4 = data["aparam4"];
                    this.abalance = data["abalance"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserList/agencyUserList.ts